import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-12 pb-24 md:pb-12" data-id="element-127">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-128">
        <div className="text-center space-y-4" data-id="element-129">
          <p className="text-sm" data-id="element-130">
            © 2024 Wall Pilates 28 Días. Todos los derechos reservados.
          </p>
          <div className="flex justify-center gap-6 text-sm" data-id="element-131">
            <a href="#" className="hover:text-white transition-colors" data-id="element-132">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-133">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-134">
              Contacto
            </a>
          </div>
          <p className="text-xs text-gray-500 max-w-2xl mx-auto" data-id="element-135">
            Los resultados pueden variar de persona a persona. Este producto es
            informativo y educativo. Consulta con un profesional de la salud
            antes de comenzar cualquier programa de ejercicio o nutrición.
          </p>
        </div>
      </div>
    </footer>;
}